
import { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import { playNotificationSound } from "@/utils/notificationUtils";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // Log the 404 error
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    
    // Play a notification sound for the 404 error
    playNotificationSound('404');
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-nalc-dark">
      <div className="text-center px-4">
        <h1 className="text-9xl font-bold text-nalc-teal mb-4">404</h1>
        <p className="text-2xl text-gray-700 dark:text-gray-300 mb-8">Oops! Page not found</p>
        <p className="text-gray-500 dark:text-gray-400 max-w-md mx-auto mb-8">
          We couldn't find the page you were looking for. It might have been removed, renamed, or doesn't exist.
        </p>
        <Link to="/">
          <Button className="bg-nalc-teal hover:bg-nalc-teal/90">
            <Home className="mr-2 h-4 w-4" />
            Return to Dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
